/**
 *  Vuex Rest API
 *
 *  @model Device
 */
import Vapi from 'vuex-rest-api';
import apiConfig from '@/config/api';
import {getPaginated} from '@/helpers/general';
import {axiosInstance} from '../../plugins/axios';

/**
 *  Users on REST API
 */
export default new Vapi({
  axios: axiosInstance,
  baseURL: apiConfig.url,
  state: {
    insurances: [],
  },
})

  // Insurances
  .get({
    action: 'getInsurances',
    property: 'insurances',
    path: (params) => getPaginated(params, 'insurances'),
  }).get({
    action: 'getInsurance',
    property: 'insurance',
    path: ({id}) => `/insurances/${id}`,
  }).getStore({
    namespaced: true,
    createStateFn: true,
  });
